export default __webpack_public_path__ + "pgnv-assets/1c55dd94232cff5d5ded04db6424546a.png";